import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import {useNavigate } from "react-router-dom";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import { parseAndSetFlag } from "utils/Utils";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";

const DisbursToLMS = ({ seletedBranchCode, featureFlags }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag] = useState(false);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [toDate, setToDate] = useState(new Date());
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
  } = useApplicantStatusData({
    status: "DISBURSAL_SUCCESS",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  useEffect(() => {
    if (featureFlags) {
      parseFlags(featureFlags.showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag);
    }
  }, [featureFlags]);
  const parseFlags = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
  const [tableColumns, setTableColumns] = useState([
    { id: "applicationid", label: "Application ID", show: true },
    { id: "created", label: "Created By", show: true },
    { id: "formNumber", label: "Application Number", show: true },
    { id: "accountNumber", label: "Loan Account Number", show: true },
    { id: "linkedBranch", label: "Sourcer Branch Name", show: true },
    { id: "customerid", label: "Customer Id", show: true },
    { id: "customerName", label: "Customer Name", show: true },
    { id: "productType", label: "Product Type", show: true },
    { id: "type", label: "Application Type", show: true },
    ...(enabledSendBackStageDetails
    ? [{ id: "stageHistory", label: "Stage History" , show: true}]
    : []),
  ]);
  useEffect(() => {
    setTableColumns((prevList) =>
      prevList.map((item) => {
        switch (item.id) {
          case "linkedBranch":
            return { ...item, show: showLinkedLoanBranchFlag };
          default:
            return item;
        }
      })
    );
  }, [showLinkedLoanBranchFlag]);

  const visibleDeliverables = tableColumns.filter((item) => item.show);

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((DisbursalApplication, index) => {
        let row = {
          applicationid: DisbursalApplication.loanApplicationId,
          created: DisbursalApplication.createdBy,
          formNumber: DisbursalApplication.loanApplicationNumber,
          accountNumber: DisbursalApplication.loanAccountNumber,
          linkedBranch: DisbursalApplication.linkedLoanBranchName,
          customerid: DisbursalApplication.customerId,
          customerName: DisbursalApplication.customerName,
          type: `${removeUnderscores(
            DisbursalApplication?.applicationType
          )} / ${removeUnderscores(DisbursalApplication?.applicationSubType)}`,
          totalCollateralValue: DisbursalApplication?.totalCollateralValue,
          mobile: DisbursalApplication.mobileNumber?.trim(),
          initiator: DisbursalApplication?.initiator,
          disbursalAmount: DisbursalApplication?.disbursalAmount,
          branchCode: DisbursalApplication?.branchCode?.trim(),
          productType: DisbursalApplication?.productType,
          ...(enabledSendBackStageDetails
          ? {
              stageHistory: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {Number(
                    DisbursalApplication?.applicationStageHistoryCount
                  ) > 0 && (
                    <ViewDetailsLink
                      onClick={() => {
                        setSelectedLeadId(
                          DisbursalApplication?.loanApplicationId
                        );
                        setStageHistoryModal(true);
                      }}
                    />
                  )}
                </div>
              ),
            }
          : {}),
        };
        reportData.push(row);
      });

    setSelectedTableData(reportData);
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanApplicationNumber,
    customerProcessId,
    loanAccNumber,
    totalCollateralValue,
    initiator,
    mobileNumber,
    branchCode,
    disbursalAmount,
    productType
  ) => {
    console.log(disbursalAmount,"dfaljfbajdkbf")
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
      const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0];
    if (result?.data?.prepledgeLoanAccountNumber) {
      setCallInProgress(true);
      const result1 = await apiHandler({
        url: `${endpoint.GET_ADJUSTED_LOAN_DATA}${prepledgeLoanAccountNumber}`,
        authToken,
      });
      setCallInProgress(false);
      await getInsuranceData(
        loanApplicationId,
        loanApplicationNumber,
        customerProcessId,
        loanAccNumber,
        totalCollateralValue,
        initiator,
        mobileNumber,
        result?.data,
        result1?.data?.disbursalDetails?.[0]?.disbursalDate,
        disbursalAmount,
        productType
      );
    } else {
      await getInsuranceData(
        loanApplicationId,
        loanApplicationNumber,
        customerProcessId,
        loanAccNumber,
        totalCollateralValue,
        initiator,
        mobileNumber,
        result?.data,
        "",
        disbursalAmount,
        productType
      );
    }
  };
  const getInsuranceData = async (
    loanApplicationId,
    loanApplicationNumber,
    customerProcessId,
    loanAccNumber,
    totalCollateralValue,
    initiator,
    mobileNumber,
    loanStatusApiData,
    disbursalDate,
    disbursalAmount,
    productType
  ) => {
    const insuranceResult = await apiHandler({
      url: endpoint.GET_INSURANCE_PREMIUM + loanApplicationId,
      authToken: authToken,
    });
     const prepledgeLoanMap = loanStatusApiData?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = loanStatusApiData?.prepledgeLoanAccountNumber ? loanStatusApiData?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0];
    const insuranceFLag = Number(insuranceResult?.data?.totalPremium) > 0;
    const navigationData = {
      loanApplicationId: loanApplicationId,
      loanApplicationNumbedisbusalDetails: loanApplicationNumber,
      status: "DISBURSALTOLMS",
      subStatus: loanStatusApiData?.applicationSubType,
      editable: false,
      customerProceedId: customerProcessId,
      loanAccountNumber: loanAccNumber,
      prePledgeLoan: prepledgeLoanAccountNumber,
      prePledgeDisbursalDate: disbursalDate,
      totalCollateralValue: totalCollateralValue,
      loanType: loanStatusApiData?.applicationType,
      mobileNum: mobileNumber,
      enabledInsurance: insuranceFLag,
      initiatorType: initiator,
      seletedBranchCode: seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap,
      disbursalAmount,
      productType,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label=" Disburse To LMS"
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={visibleDeliverables}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="disburseToLms"
        />
      </Grid>
      <StageHistoryModal
        open={stageHistoryModal}
        onClose={() => {
          setStageHistoryModal(false);
          setSelectedLeadId(null);
        }}
        leadId={selectedLeadId}
        authToken={authToken}
      />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {(callInProgress || applicantDataLoading) && <CircularProgresss callInProgress />}
    </Grid>
  );
};

DisbursToLMS.propTypes = {
  classes: PropTypes.object,
};

export default DisbursToLMS;
